import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {RestapiService} from '../../services/restapi.service';
declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    //{ path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/home-setting', title: 'Setting',  icon: 'settings', class: '' },
    { path: '/admin-list', title: 'Admins',  icon:'people', class: '' },
    // { path: '/users-list', title: 'Users',  icon:'people', class: '' },
    { path: '/games-list', title: 'Games',  icon:'games', class: '' },
    { path: '/cate-list', title: 'Category',  icon:'category', class: '' },
    { path: '/tournaments-list', title: 'Tournaments',  icon:'tournaments', class: '' },
    { path: '/subscription-plans', title: 'Subscription Plans',  icon:'subscriptions', class: '' },
    //{ path: '/user-profile', title: 'User Profile',  icon:'person', class: '' },
    //{ path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
    //{ path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
    //{ path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
    //{ path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  allItems:any[];

  constructor(public RestapiService:RestapiService,private router: Router) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  
  async logout(){
    sessionStorage.clear() 
    await this.RestapiService.getMethod('user/logout/');
    window.location.reload();

  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
